import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'
import { Play } from './icons'

class HeroBannerAbout extends Component {

  render() {

    let { image, title, content, video, extraPaddingBottom, extraPaddingNoStats, projectVideo, projectVideoOnClick } = this.props

    return (
      <section className={`hero-banner-about ${extraPaddingBottom ? 'hero-banner-about--extra-padding' : ''} ${extraPaddingNoStats ? 'hero-banner-about--extra-padding-no-stats' : ''}`}>

        <div className='hero-banner-about__inner'>
          
            <div className='hero-banner-about__content'>

              <div className='hero-banner-about__details'>

                <Fade bottom distance='40px' duration={1000}>
                  <div className='hero-banner-about__heading'>

                    <h2 className='heading'>{ title }</h2>

                    <div className='copy' dangerouslySetInnerHTML={{ __html: content }} />

                  </div>
                </Fade>

              </div>

              <div className='hero-banner-about__image'>

                { image?.sourceUrl && <img src={image?.sourceUrl} alt={title} /> }
                { video && <video src={video} autoPlay muted playsInline loop /> }




              </div>

            </div>
            { projectVideo &&
            <span className='hero-banner-about__play-video' onClick={projectVideoOnClick}>
              <Play color={'#FFFFFF'} />
              Play Video
            </span>
  }

        </div>


      
      </section>
    )
  }
}

export default HeroBannerAbout
